import imageField from 'molecules/Image/config';

import type { Input } from '@builder.io/sdk';

export const imageMarqueFields = [
  { ...imageField('image') },
  {
    name: 'type',
    type: 'enum',
    enum: ['full', 'border'],
    defaultValue: 'border',
  },
] as const satisfies DeepReadonly<Input[]>;

const imageMarqueConfig = {
  name: 'Image Marque',
  inputs: imageMarqueFields,
};

export type ImageMarqueProps = GenerateBuilder<typeof imageMarqueFields>;

export default imageMarqueConfig;
